import { FC } from "react";
import { OurTeam } from "../components/OurTeam";

export const Team: FC = () => (
  <>
    <OurTeam />
  </>
);
